module.exports = __webpack_public_path__ + "img/logo_scopos.a17e1e8e.png";